module.exports = __webpack_public_path__ + "img/i1.09f5a9de.png";